// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__MwkDN","text":"Contact_text__2UebD","links":"Contact_links__7SuZ2","link":"Contact_link__T3v-S"};